import { sanitizeProductName } from './sanitizeProductName';
import { ProductNameProp } from './types';

type GetReleaseNotesForProductProps = ProductNameProp;

/**
 * The data sheet page on tanium.com for the given product.
 */
export const getDataSheetForProduct = ({ productName }: GetReleaseNotesForProductProps) => {
  const sanitizedProductName = sanitizeProductName({ delimiter: '-', productName });
  return `https://www.tanium.com/resources/tanium-${sanitizedProductName}-data-sheet`;
};
